import { FaArrowLeft } from 'react-icons/fa'
import { Link } from '../lib/router'

const sectionStyle: React.CSSProperties = {
  minHeight: '100vh',
  padding: '120px 1.5rem 4rem',
  display: 'flex',
  justifyContent: 'center',
}

const containerStyle: React.CSSProperties = {
  maxWidth: '800px',
  width: '100%',
}

const headerStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: '2rem',
  paddingBottom: '1rem',
  borderBottom: '1px solid var(--border-color)',
}

const cardStyle: React.CSSProperties = {
  background: 'var(--card-bg)',
  backdropFilter: 'blur(8px)',
  border: '1px solid var(--border-color)',
  borderRadius: '12px',
  padding: '2rem',
  lineHeight: '1.7',
  color: 'var(--text-secondary)',
}

const headingStyle: React.CSSProperties = {
  fontSize: '1.2rem',
  fontWeight: 600,
  marginTop: '1.5rem',
  marginBottom: '0.5rem',
  color: 'var(--accent-color)',
}

const backLinkStyle: React.CSSProperties = {
  color: 'var(--text-secondary)',
  textDecoration: 'none',
  fontSize: '0.9rem',
  display: 'inline-flex',
  alignItems: 'center',
  gap: '0.4rem',
  transition: 'color 0.25s',
}

const TermsPage = () => (
  <section style={sectionStyle}>
    <div style={containerStyle}>
      <div style={headerStyle}>
        <h1 style={{ fontSize: '1.5rem', fontWeight: 700, color: 'var(--accent-color)', margin: 0 }}>
          Terms &amp; Conditions
        </h1>
        <Link href="/#top" style={backLinkStyle}>
          <FaArrowLeft size={12} /> Back to Portfolio
        </Link>
      </div>
      <div style={cardStyle}>
        <p style={{ marginBottom: '0.8rem' }}><strong style={{ color: 'var(--text-primary)' }}>Effective Date:</strong> June 12, 2026</p>

        <h2 style={headingStyle}>1. Acceptance of Terms</h2>
        <p>By accessing and using this website (mohitarora.me), you agree to these Terms &amp; Conditions. If you do not agree, please discontinue use immediately.</p>

        <h2 style={headingStyle}>2. Intellectual Property</h2>
        <p>All content on this website, including but not limited to text, graphics, logos, code, project descriptions, and portfolio materials, is the intellectual property of Mohit Arora unless otherwise attributed. You may not reproduce, distribute, or create derivative works without explicit written permission.</p>

        <h2 style={headingStyle}>3. Use of Content</h2>
        <p>You are permitted to view and share links to the portfolio with proper attribution. You may not copy, scrape, or misrepresent the work as your own.</p>

        <h2 style={headingStyle}>4. Third-Party Links</h2>
        <p>This website contains links to third-party services (GitHub, LinkedIn, etc.). I am not responsible for the content, privacy practices, or terms of these external sites.</p>

        <h2 style={headingStyle}>5. Disclaimer</h2>
        <p>This portfolio is provided &quot;as is&quot; without warranties of any kind, express or implied. While I strive for accuracy, I make no guarantees regarding the completeness or reliability of the information presented.</p>

        <h2 style={headingStyle}>6. Limitation of Liability</h2>
        <p>Mohit Arora shall not be liable for any damages arising from the use or inability to use this website, including but not limited to direct, indirect, incidental, or consequential damages.</p>

        <h2 style={headingStyle}>7. Changes to Terms</h2>
        <p>These terms may be updated at any time. Continued use after changes constitutes acceptance of the new terms.</p>

        <h2 style={headingStyle}>8. Contact</h2>
        <p>Email: <a href="mailto:cs.mohitaroraofficial@gmail.com" style={{ color: 'var(--accent-color)' }}>cs.mohitaroraofficial@gmail.com</a></p>

        <p style={{ fontSize: '0.85rem', opacity: 0.6, marginTop: '1.5rem', textAlign: 'center' }}>Last updated: June 12, 2026</p>
      </div>
    </div>
  </section>
)

export default TermsPage
